import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { USER_ROLE_ACTION_TYPE } from '../actions';

const initialState = {};

const userRolesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case USER_ROLE_ACTION_TYPE.GET_USER_ROLES:
        return payload || initialState;

      case USER_ROLE_ACTION_TYPE.SET_USER_ROLE:
        draft[payload.id] = payload;
        break;

      case USER_ROLE_ACTION_TYPE.DELETE_USER_ROLE:
        delete draft[meta.roleId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default userRolesReducer;
